module.exports = __webpack_public_path__ + "img/banner_default.1a11aac9.png";